import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@otcmarketsgroup/otcm-ui-lib';

const Title = ({ id, title, className }) => {
  return <Box id={id} className={className}>
    <Typography variant='h4'>{title}</Typography>
  </Box>;
};

Title.propTypes = {
  id: PropTypes.string,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.object]),
  className: PropTypes.string,
};

export default Title;
